import { render, staticRenderFns } from "./SearchTab.vue?vue&type=template&id=f2e32fe2&scoped=true&"
import script from "./SearchTab.vue?vue&type=script&lang=ts&"
export * from "./SearchTab.vue?vue&type=script&lang=ts&"
import style0 from "./SearchTab.vue?vue&type=style&index=0&id=f2e32fe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e32fe2",
  null
  
)

/* custom blocks */
import block0 from "./SearchTab.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab})
